import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleManageBiddersPageTourConfig: AgTechTourConfig = {
    id: 'sale-manage-bidders-page-tour',
    name: 'Manage Bidders Tour',
    steps: [
        {
            targetId: 'sale-bidders-grid',
            title: 'Bidders Grid',
            description: 'Lists all registered bidders for this sale. You can search by name or bidder number, sort columns, and export the list to Excel.',
            position: 'right',
        },
        {
            targetId: 'sale-bidders-count-metric',
            title: 'Registered Bidders',
            description: 'The current count of bidders registered for this sale.',
            position: 'left',
        },
        {
            targetId: 'sale-bidders-register-btn',
            title: 'Register Bidders',
            description: 'Click here to register a new bidder. You can select an existing contact or create a new one on the spot.',
            position: 'left',
        },
    ]
}
